<script setup lang="ts">
import type { NavigationEntry } from '@/navigation';
import { ref } from 'vue';
import { onMounted } from 'vue';
import TileItem from '@/components/TileItem/TileItem.vue';

export interface TileNavigationItemProps {
  item: NavigationEntry;
  onRendered: (tileHeight: number) => void;
  minHeight: number;
}

const props = defineProps<TileNavigationItemProps>();

const tileRef = ref<HTMLDivElement | null>(null);

// trigger custom render handler
onMounted(() => {
  const tileElement = tileRef.value;
  if (tileElement && props.onRendered) {
    const tileHeight = tileElement.clientHeight;
    props.onRendered(tileHeight);
  }
});
</script>

<template>
  <div ref="tileRef" class="tile-nav item">
    <router-link v-if="item.route" :to="item.route">
      <TileItem
        :color="item.color"
        :title="$t(item.titleI18n)"
        :description="item.descriptionI18n ? $t(item.descriptionI18n) : ''"
        :icon="item.icon"
        :minHeight="minHeight"
        data-testid="tileNavItem"
      />
    </router-link>
  </div>
</template>
<style lang="scss" scoped>
.item {
  width: 300px;
  margin-left: 24px;
  margin-top: 32px;

  a {
    text-decoration: none;
  }
}
</style>
